import { gql } from '@apollo/client';

export const FETCH_ORG_MODULES = gql`
  query findOrgModules($orgId: ID!) {
    org_modules(
      where: {
        org_pointer: { have: { objectId: { equalTo: $orgId } } }
        enabled: { equalTo: true }
      }
      first: 1000
    ) {
      edges {
        node {
          objectId
          module_pointer {
            objectId
            name
            price_for_quantity
            included_quantity
          }
          enabled
        }
      }
    }
  }
`;
